import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useSearchParams } from 'react-router-dom';
import * as terapiaService from "../../services/terapiaService";
import { Grid, Card, CardContent, Snackbar, Alert } from '@mui/material';
import Therapy from '../../components/Therapy'
import TherapySchedule from '../../components/TherapySchedule'
import TherapyTherapist from '../../components/TherapyTherapist'
import TherapyMember from '../../components/TherapyMember'
import MantenimientoForm from '../../components/common/MantenimientoForm';
import { useMantenimiento } from '../../hooks/useMantenimiento';
import { activeValidations as activeValidationsTherapy } from '../../redux/therapySlice';
import { setEntity as setTherapySchedule, activeValidations as activeTherapySchedule } from '../../redux/therapyScheduleSlice';
import { setEntity as setTherapyTherapist, activeValidations as activeTherapyTherapist } from '../../redux/therapyTherapistSlice';
import { setEntity as setTherapyMember, activeValidations as activeTherapyMember } from '../../redux/therapyMemberSlice';

const Edit = (props) => {
   const therapy = useSelector((state) => state.therapy.entity);
   const therapySchedule = useSelector((state) => state.therapySchedule.entity);
   const therapyTherapist = useSelector((state) => state.therapyTherapist.entity);
   const therapyMember = useSelector((state) => state.therapyMember.entity);
   const therapyValidation = useSelector((state) => state.therapy.validationMessage);
   const therapyScheduleValidation = useSelector((state) => state.therapySchedule.validationMessage);
   const therapyTherapistValidation = useSelector((state) => state.therapyTherapist.validationMessage);
   const therapyMemberValidation = useSelector((state) => state.therapyMember.validationMessage);

   const defaultTherapySchedule = useSelector((state) => state.therapySchedule.defaultEntity)
   const defaultTherapyTherapist = useSelector((state) => state.therapyTherapist.defaultEntity)
   const defaultTherapyMember = useSelector((state) => state.therapyMember.defaultEntity)
  const [openMessage, setOpenMessage] = useState(false)
  const onCloseMessage = () => { setOpenMessage(!openMessage); }
  const [propsMessage, setPropsMessage] = useState({ severity: "success", message: "" });
  const dispatch = useDispatch();
  const params = useParams();
  // La terapia se puede registrar desde el detalle de una atencion ya guardada:
  // en ese caso viaja el idAtencion y la atencion no se crea de nuevo.
  const [searchParams] = useSearchParams();
  const idAtencion = parseInt(searchParams.get("idAtencion") || "0");
  const { isReadOnly, setIsReadOnly } = useMantenimiento("terapia");
  const idFilialUsuario = useSelector((state) => state.seguridad?.idFilial) || 0;
  const postEntity = async () => {
    const filialEfectiva = therapy.idFilial || (idFilialUsuario > 0 ? idFilialUsuario : 0);
    const idSalonEfectivo = therapy.idSalon ? (parseInt(therapy.idSalon, 10) || null) : null;
    var dataPost = {
      ...therapy,
      idFilial: filialEfectiva > 0 ? filialEfectiva : null,
      idSalon: idSalonEfectivo,
      terapiaHorario: therapySchedule,
      terapiaTerapeuta: therapyTherapist,
      terapiaParticipante: (therapyMember || []).map((m) => ({ ...m, idDescuento: m.idDescuento > 0 ? m.idDescuento : null, montoDescuento: m.montoDescuento > 0 ? m.montoDescuento : null })),
      idAtencion: idAtencion
    }

    var ValidationMessages = therapyValidation.concat(therapyMemberValidation).concat(therapyScheduleValidation).concat(therapyTherapistValidation)

    console.log(dataPost)
    console.log(ValidationMessages)

    // Validar que un terapeuta y un participante no sean la misma persona
    const coincidencia = (therapyTherapist || []).find((t) => {
      if (!t.idTerapeuta || t.idTerapeuta <= 0) return false;
      return (therapyMember || []).some((m) => {
        if (!m.idParticipante || m.idParticipante <= 0) return false;
        if (m.idPersona && Number(m.idPersona) === Number(t.idTerapeuta)) return true;
        if (t.terapeuta && m.participante &&
            t.terapeuta.trim().toLowerCase() === m.participante.trim().toLowerCase()) {
          return true;
        }
        return false;
      });
    });

    if (coincidencia) {
      const nombre = coincidencia.terapeuta || "seleccionada";
      setPropsMessage({
        severity: "error",
        message: `El terapeuta y el participante no pueden ser la misma persona (${nombre.trim()}).`
      });
      setOpenMessage(true);
      return;
    }

    if (ValidationMessages.length > 0) {
      dispatch(activeValidationsTherapy());
      dispatch(activeTherapySchedule());
      dispatch(activeTherapyTherapist());
      dispatch(activeTherapyMember());

      setPropsMessage({ severity: "error", message: ValidationMessages.join(" - ") })
      setOpenMessage(true);
    }
    else {
      await terapiaService.addUpdateTherapyWithDetails(dataPost)
        .then(response => {
          setPropsMessage({ severity: "success", message: "Se guardaron los datos con exito" })
          setOpenMessage(true);
          setIsReadOnly(true);

          if (therapy.id > 0){
            terapiaService.getsTerapiaHorarioView(therapy.id)
            .then(data => {
              if (data === null || data.length === 0)
                dispatch(setTherapySchedule(defaultTherapySchedule));
              else
                dispatch(setTherapySchedule(data));
            })
            .catch((err) => {
              console.log("Err: ", err);
            });

            terapiaService.getsTerapiaTerapeutaView(therapy.id)
            .then(data => {
              if (data === null || data.length === 0)
                dispatch(setTherapyTherapist(defaultTherapyTherapist));
              else
                dispatch(setTherapyTherapist(data));
            })
            .catch((err) => {
              console.log("Err: ", err);
            });

            terapiaService.getsTerapiaParticipanteView(therapy.id)
            .then(data => {
              if (data === null || data.length === 0)
                dispatch(setTherapyMember(defaultTherapyMember));
              else
                dispatch(setTherapyMember(data));
            })
            .catch((err) => {
              console.log("Err: ", err);
            });
          }
        })
        .catch(error => {
          const msg = error?.response?.data?.message || error?.response?.data?.detail || error?.message || "Hubo un error";
          setPropsMessage({ severity: "error", message: msg })
          setOpenMessage(true);
        });
    }
  }

  return (
    <div>
      <MantenimientoForm
        title={(params.id == 0 ? "Nueva" : "Editar") + " Terapia"}
        backTo={"/therapy"}
        onSave={postEntity}
        disabled={isReadOnly}
      >
        <Grid container spacing={1} sx={{
          "& .MuiGrid-root>.MuiGrid-item": {
            paddingTop: "8px"
          },
        }}>
          <Grid item xs={12} sm={12}>
            <Card >
              <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                <Therapy isReadOnly={isReadOnly} />
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12}>
            <Card>
              <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                <TherapyTherapist isReadOnly={isReadOnly} />
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} xl={6}>
            <Card>
              <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                <TherapyMember isReadOnly={isReadOnly} />
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} xl={6}>
            <Card>
              <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                <TherapySchedule isReadOnly={isReadOnly} />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </MantenimientoForm>
      <Snackbar open={openMessage} autoHideDuration={5000} onClose={onCloseMessage}
        anchorOrigin={{vertical: "top", horizontal: "center"}}>
        <Alert onClose={onCloseMessage} severity={propsMessage.severity}>
          {propsMessage.message}
        </Alert>
      </Snackbar>
    </div>
  )
}

export default Edit
